export default __webpack_public_path__ + "static/media/demo2.ea83581a.gif";